/**
 * Добавляет CSS стили для админ-компонентов
 */
export function addAdminStyles() {
    if (document.getElementById('admin-styles')) {
        return; // Стили уже добавлены
    }

    const styleElement = document.createElement('style');
    styleElement.id = 'admin-styles';
    styleElement.innerHTML = `
        /* Admin Toolbar Styles */
        .admin-toolbar {
            background-color: #23282d;
            color: #fff;
            padding: 8px 0;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 9999;
        }

        .admin-welcome {
            font-size: 14px;
        }

        .admin-actions {
            display: flex;
            gap: 10px;
        }

        .toolbar-btn {
            background-color: rgba(255, 255, 255, 0.1);
            border: none;
            color: #fff;
            padding: 5px 10px;
            border-radius: 4px;
            font-size: 14px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 5px;
            transition: background-color 0.2s;
        }

        .toolbar-btn:hover {
            background-color: rgba(255, 255, 255, 0.2);
        }

        /* SEO Modal Styles */
        .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.7);
            z-index: 10000;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .seo-modal-content {
            background-color: #fff;
            width: 90%;
            max-width: 900px;
            max-height: 90vh;
            border-radius: 8px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
            overflow: hidden;
            display: flex;
            flex-direction: column;
        }

        .modal-header {
            padding: 15px 20px;
            border-bottom: 1px solid #e5e5e5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #009dc9;
            color: white;
        }

        .modal-header h2 {
            margin: 0;
            font-size: 22px;
            font-weight: 500;
        }

        .close-btn {
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: white;
        }

        .modal-body {
            padding: 20px;
            overflow-y: auto;
        }

        .modal-footer {
            padding: 15px 20px;
            border-top: 1px solid #e5e5e5;
            display: flex;
            justify-content: flex-end;
            gap: 10px;
        }

        /* Adjust the main content when admin toolbar is visible */
        body.admin-mode {
            padding-top: 40px; /* Height of the admin toolbar */
        }

        /* Make the body fixed when modal is open to prevent scrolling */
        body.modal-open {
            overflow: hidden;
        }
    `;

    document.head.appendChild(styleElement);
}